import tinycolor from "tinycolor2";

/**
 * @param {string} color - #5da1a9
 * @param {number} alpha - 10
 * @returns {string}
 */
export const lighten = (color, alpha) => {
  return tinycolor(color)
    .lighten(alpha)
    .toString();
};

/**
 * @param {string} color - #5da1a9
 * @param {number} alpha - 10
 * @returns {string}
 */
export const darken = (color, alpha) => {
  return tinycolor(color)
    .darken(alpha)
    .toString();
};
